import { render, staticRenderFns } from "./SchoolLogo.vue?vue&type=template&id=3d300d4c&"
import script from "./SchoolLogo.vue?vue&type=script&lang=js&"
export * from "./SchoolLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports